import { IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import ErrorIcon from '@material-ui/icons/Error';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import InfoIcon from '@material-ui/icons/Info';
import WarningIcon from '@material-ui/icons/Warning';
import { SnackbarProvider, SnackbarOrigin } from 'notistack';
import api from 'configs/api';
import React from 'react';
import useStyles from './style';

const CustomSnackBarProvider: React.FC = ({ children }) => {
  const classes = useStyles();
  const notistackRef = React.useRef<SnackbarProvider | null>(null);

  const onClickDismiss = key => () => {
    notistackRef?.current?.closeSnackbar(key);
  };

  const defaultConfig = React.useMemo<SnackbarOrigin>(
    () => ({
      vertical: 'bottom',
      horizontal: 'center',
    }),
    [],
  );

  const messagesInterceptor = response => {
    const { data } = response;
    // const { data, config } = response;
    const faixa200 = data.statusCode >= 200 && data.statusCode <= 299;
    const faixa400 =
      data.statusCode === 400 ||
      (data.statusCode >= 402 && data.statusCode <= 499);
    if (data.messages && (faixa200 || faixa400)) {
      const type = faixa200 ? 'success' : 'error';
      if (Array.isArray(data.messages)) {
        data.messages.forEach(msg =>
          notistackRef?.current?.enqueueSnackbar(msg, {
            variant: type,
            // autoHideDuration: config.url === 'equipment/add' ? null : 3e4,,
          }),
        );
      } else {
        notistackRef?.current?.enqueueSnackbar(data.messages, {
          variant: type,
          // autoHideDuration: config.url === 'equipment/add' ? null : 3e4,
        });
      }
    }
    return response;
  };

  React.useEffect(() => {
    api.interceptors.response.use(
      response => {
        messagesInterceptor(response);
        return response;
      },
      error => {
        const { response } = error;
        messagesInterceptor(response);
        return Promise.reject(error);
      },
    );
  }, []);

  return (
    <SnackbarProvider
      autoHideDuration={3e4}
      ref={notistackRef}
      classes={{
        variantSuccess: classes.success,
        variantError: classes.error,
        variantWarning: classes.warning,
        variantInfo: classes.info,
      }}
      iconVariant={{
        error: <ErrorIcon aria-label="Ícone de erro" />,
        info: <InfoIcon aria-label="Ícone de informação" />,
        success: <CheckCircleIcon aria-label="Ícone de sucesso" />,
        warning: <WarningIcon aria-label="Ícone de aviso" />,
      }}
      anchorOrigin={defaultConfig}
      maxSnack={6}
      action={key => (
        <IconButton
          aria-label="close"
          color="inherit"
          onClick={onClickDismiss(key)}
          className={classes.close}
        >
          <CloseIcon />
        </IconButton>
      )}
    >
      {children}
    </SnackbarProvider>
  );
};

export { CustomSnackBarProvider };
